import { render, staticRenderFns } from "./ComponentAside.vue?vue&type=template&id=973efc30&scoped=true"
import script from "./ComponentAside.vue?vue&type=script&lang=js"
export * from "./ComponentAside.vue?vue&type=script&lang=js"
import style0 from "./ComponentAside.vue?vue&type=style&index=0&id=973efc30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973efc30",
  null
  
)

export default component.exports